import DispatchConstants from 'app/shared/constants/DispatchConstants';

const CookiesActions = {
    updateUserCookies(data) {
        return dispatch => dispatch({
            type: DispatchConstants.UPDATE_USER_INFO,
            payload: data,
        });
    },
};

export default CookiesActions;
